import {ERROR, SIGN_IN, SIGNED_IN, LOADING, LOGGED_OUT} from "module/constants";
import common from "module/common";
import socket from 'module/socket';
import Moment from 'moment';
import Cookies from 'js-cookie';

let googleAuth = null;

const DOMAINS = ['projectestimator.services', 'pes.ltd', 'easypricepro.com', 'buildaviator.services'];
const CLIENT_ID_LIVE = '233047984860-13airm73c8fsso2m883abi7jnaf29scv.apps.googleusercontent.com';
const CLIENT_ID_TEST = '233047984860-cif048qkbo37jbtlv3efakuk0seqad4c.apps.googleusercontent.com';

const google = window.google;

const LOGGED_IN_USER = 'loggedInUser';

const SET_STATE = 'loggedInState';
const SET_STATE_REASON = 'loggedInStateReason';

const SET_LOGGED_IN_USER = 'loggedInUser';
const SET_ALL_USERS = 'allUsers';

let signInAttemptNumber = 0;

export const actions = {
  initGoogle({commit, dispatch, getters, rootGetters}) {
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    if (isSafari) {
      commit(SET_STATE, SIGN_IN);
      return;
    }

    const sessionAuthorised = Cookies.get(SESSION_AUTHORIZED);
    // Loose type is on purpose because of different browser behaviour
    if (sessionAuthorised != 1) {
      google.accounts.id.initialize({
        client_id: process.env.NODE_ENV === 'production' ? CLIENT_ID_LIVE : CLIENT_ID_TEST,
        itp_support: true,
        auto_select: true,
        cancel_on_tap_outside: false,
        callback: (response) => {
          commit(SET_STATE, LOADING);
          dispatch('verify', response.credential);
          googleAuth = response.credential;
        }
      });

      const element = document.querySelector('.sign-in-container .google-sign-in');

      dispatch('renderButton', element);
    } else {
      commit(SET_STATE, LOADING);
      dispatch('initEmailToken');
    }
  },
  verify({commit, dispatch}, user) {
    if (user === null) {
      return;
    }

    const decodedUser = common.parseJwt(user);
    if (DOMAINS.indexOf(decodedUser.hd) <= -1) {
      dispatch('logoutUserWithGoogle');

      commit(SET_STATE, ERROR);
      commit(SET_STATE_REASON, 'Google Account Not Supported Please Use Email Login');
      return;
    }

    signInAttemptNumber++;

    common
        .httpPost('verify')
        .type('form')
        .data({idToken: user})
        .then((res) => {
          commit(SET_STATE, SIGNED_IN);
          commit(SET_LOGGED_IN_USER, res.data.loggedInUser);
          dispatch('brand/load', null, {root: true});
          socket.validate(user);
        }, (error) => {
          if (_.get(error, 'data.message', null) === 'Expired or Invalid Session' && signInAttemptNumber <= 2) {
            commit(SET_STATE, LOADING);
            dispatch('refreshAndVerify');
          } else {
            commit(SET_STATE, ERROR);
            commit(SET_STATE_REASON, _.get(error, 'data.message', null));
            google.accounts.id.revoke(googleAuth, done => {
              googleAuth = null;
            });
          }
        });
  },
  renderButton({commit, dispatch}, el) {
    google.accounts.id.renderButton(
        el,
        {theme: 'outline', size: 'large', shape: 'pill', width: 240}  // customization attributes
    );
    google.accounts.id.prompt()
  },
  logoutUserWithGoogle({commit, dispatch}) {
    google.accounts.id.revoke(common.parseJwt(googleAuth).email, done => {
      if (done.successful) {
        commit(SET_STATE_REASON, 'User logged out');
        googleAuth = null;
        google.accounts.id.disableAutoSelect();
      }

      google.accounts.id.initialize({
        client_id: process.env.NODE_ENV === 'production' ? CLIENT_ID_LIVE : CLIENT_ID_TEST,
        itp_support: true,
        auto_select: false,
        callback: (response) => {
          commit(SET_STATE, LOADING);
          dispatch('verify', response.credential);
          googleAuth = response.credential;
        }
      });

      const element = document.querySelector('.sign-in-container .google-sign-in');

      dispatch('renderButton', element);
    });
  },
  refreshAndVerify({commit, dispatch}) {
    try {
      google.accounts.id.initialize({
        client_id: process.env.NODE_ENV === 'production' ? CLIENT_ID_LIVE : CLIENT_ID_TEST,
        itp_support: true,
        auto_select: true,
        cancel_on_tap_outside: false,
        callback: (response) => {
          commit(SET_STATE, LOADING);
          dispatch('verify', response.credential);
          googleAuth = response.credential;
        }
      });
    } catch (error) {
      commit(SET_STATE, ERROR);
      commit(SET_STATE_REASON, _.get(error, 'data.message', null));
      google.accounts.id.revoke(googleAuth, done => {
        googleAuth = null;
      });
    }
  }
};

export const getters = {
  idToken: (state) => () => {
    let idToken = null;

    if (googleAuth && state[LOGGED_IN_USER].state.state === SIGNED_IN) {
      idToken = googleAuth;
    }

    return _.isEmpty(idToken) === false ? idToken : null;
  },
};